export default __webpack_public_path__ + "static/tribugen-e45a00218428db878a0e67dad28ffdde.jpg";